<template>
    <div class="export-pickup clearfix" style="position: relative">
        <Form :model="formData" :labelWidth="100">
            <FormItem
                :label="
                    $t('erp.b2c.Platform_carrier', {
                        defaultValue: '平台承运商',
                    })
                "
                required
                style="width: 500px; padding-top: 10px"
            >
                <Input v-model="formData.channelMethodCode" />
            </FormItem>
            <FormItem
                :label="
                    $t('erp.b2c.shipping_method', {
                        defaultValue: '发货方式',
                    })
                "
                required
                style="width: 500px"
            >
                <Select
                    dropStyle="width:auto"
                    v-model="formData.shippingMethodCode"
                    filterable
                    @on-change="changeShippingMethod"
                    :placeholder="
                        $t('global.common.choose', {
                            defaultValue: '请选择',
                        })
                    "
                >
                    <Option
                        v-for="(item, index) in this.fbaServices"
                        :value="item.value"
                        :key="index"
                        >{{ item.label }}</Option
                    >
                </Select>
            </FormItem>
            <div
                v-if="formData.shippingMethodCode != 'FBA-LTL'"
                style="padding-left: 30px"
            >
                <vButton class="but" theme="primary" @click="shiplabelPropFile"
                    ><span style="color: red; margin-right: 5px">*</span
                    >Shippinglabel</vButton
                >
                <span class="reimbursementUpload">
                    <div class="upload">
                        <div
                            class="upload-item"
                            v-for="(item, index) in shiplabelAttachMetas.items"
                            :key="item.key"
                        >
                            <div class="filename">
                                {{ item.filename }}
                            </div>
                            <div>
                                <Icon
                                    class="close"
                                    size="13"
                                    type="md-close"
                                    @click="shiplabelClearPropUpload(index)"
                                />
                            </div>
                        </div>
                    </div>
                </span>
            </div>
            <div
                v-if="formData.shippingMethodCode == 'FBA-LTL'"
                style="padding-left: 30px"
            >
                <vButton class="but" theme="primary" @click="bolPropFile"
                    ><span style="color: red; margin-right: 5px">*</span
                    >BOL</vButton
                >
                <span class="reimbursementUpload">
                    <div class="upload">
                        <div
                            class="upload-item"
                            v-for="(item, index) in bolAttachMetas.items"
                            :key="item.key"
                        >
                            <div class="filename">
                                {{ item.filename }}
                            </div>
                            <div>
                                <Icon
                                    class="close"
                                    size="13"
                                    type="md-close"
                                    @click="bolClearPropUpload(index)"
                                />
                            </div>
                        </div>
                    </div>
                </span>
            </div>
            <div style="padding-left: 30px; padding-top: 10px">
                <vButton
                    class="but"
                    theme="primary"
                    @click="CartonLabelPropFile"
                    ><span style="color: red; margin-right: 5px">*</span
                    >CartonLabel</vButton
                >
                <span class="reimbursementUpload">
                    <div class="upload">
                        <div
                            class="upload-item"
                            v-for="(
                                item, index
                            ) in CartonLabelAttachMetas.items"
                            :key="item.key"
                        >
                            <div class="filename">
                                {{ item.filename }}
                            </div>
                            <div>
                                <Icon
                                    class="close"
                                    size="13"
                                    type="md-close"
                                    @click="CartonLabelClearPropUpload(index)"
                                />
                            </div>
                        </div>
                    </div>
                </span>
            </div>
            <div
                v-if="formData.shippingMethodCode == 'FBA-LTL'"
                style="padding-left: 30px; padding-top: 10px"
            >
                <vButton
                    class="but"
                    theme="primary"
                    @click="PalletLabelPropFile"
                    >PalletLabel</vButton
                >
                <span class="reimbursementUpload">
                    <div class="upload">
                        <div
                            class="upload-item"
                            v-for="(
                                item, index
                            ) in PalletLabelAttachMetas.items"
                            :key="item.key"
                        >
                            <div class="filename">
                                {{ item.filename }}
                            </div>
                            <div>
                                <Icon
                                    class="close"
                                    size="13"
                                    type="md-close"
                                    @click="PalletLabelClearPropUpload(index)"
                                />
                            </div>
                        </div>
                    </div>
                </span>
            </div>
            <div style="padding-left: 30px; padding-top: 10px">
                <vButton class="but" theme="primary" @click="itemlabelPropFile"
                    >itemlabel</vButton
                >
                <span class="reimbursementUpload">
                    <div class="upload">
                        <div
                            class="upload-item"
                            v-for="(item, index) in itemlabelAttachMetas.items"
                            :key="item.key"
                        >
                            <div class="filename">
                                {{ item.filename }}
                            </div>
                            <div>
                                <Icon
                                    class="close"
                                    size="13"
                                    type="md-close"
                                    @click="itemlabelClearPropUpload(index)"
                                />
                            </div>
                        </div>
                    </div>
                </span>
            </div>
        </Form>
        <vModal
            class="hidefooter customerupload"
            v-model="shiplabelOperate.show"
            :title="shiplabelOperate.title"
            v-bind="shiplabelOperate"
        >
            <compMutiUpload
                :action="shiplabelProps.action"
                :name="shiplabelProps.name"
                :multiple="true"
                :data="shiplabelProps.data"
                @on-success="shiplabelSuccess"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
        <vModal
            class="hidefooter customerupload"
            v-model="bolOperate.show"
            :title="bolOperate.title"
            v-bind="bolOperate"
        >
            <compMutiUpload
                :action="bolProps.action"
                :name="bolProps.name"
                :multiple="true"
                :data="bolProps.data"
                @on-success="bolSuccess"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
        <vModal
            class="hidefooter customerupload"
            v-model="CartonLabelOperate.show"
            :title="CartonLabelOperate.title"
            v-bind="CartonLabelOperate"
        >
            <compMutiUpload
                :action="CartonLabelProps.action"
                :name="CartonLabelProps.name"
                :multiple="true"
                :data="CartonLabelProps.data"
                @on-success="CartonLabelSuccess"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
        <vModal
            class="hidefooter customerupload"
            v-model="PalletLabelOperate.show"
            :title="PalletLabelOperate.title"
            v-bind="PalletLabelOperate"
        >
            <compMutiUpload
                :action="PalletLabelProps.action"
                :name="PalletLabelProps.name"
                :multiple="true"
                :data="PalletLabelProps.data"
                @on-success="PalletLabelSuccess"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
        <vModal
            class="hidefooter customerupload"
            v-model="itemlabelOperate.show"
            :title="itemlabelOperate.title"
            v-bind="itemlabelOperate"
        >
            <compMutiUpload
                :action="itemlabelProps.action"
                :name="itemlabelProps.name"
                :multiple="true"
                :data="itemlabelProps.data"
                @on-success="itemlabelSuccess"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
        <div class="pull-right">
            <Button type="primary" @click="submit">{{
                $t("global.modal.confirm", { defaultValue: "确定" })
            }}</Button>
            <Button class="margin-left-15" @click="$emit('on-close')">{{
                $t("global.common.operation_cancel", { defaultValue: "取消" })
            }}</Button>
        </div>
    </div>
</template>

<script>
import { HttpPoUploadAttach } from "@/service/boss/distribution";
export default {
    props: ["orderData"],
    data() {
        return {
            formData: {},
            id: this.orderData.id,
            sourceNo: this.orderData.sourceNo,
            serviceCodeList: [],
            fbaServices: [],
            attachMetas: [],
            selectedItem: {},
            shiplabelOperate: {
                show: false,
                title: "附件上传",
                data: {},
            },
            bolOperate: {
                show: false,
                title: "附件上传",
                data: {},
            },
            CartonLabelOperate: {
                show: false,
                title: "附件上传",
                data: {},
            },
            PalletLabelOperate: {
                show: false,
                title: "附件上传",
                data: {},
            },
            itemlabelOperate: {
                show: false,
                title: "附件上传",
                data: {},
            },
            shiplabelAttachMetas: {
                items: [],
                opAt: "",
                organizationId: "",
            },
            bolAttachMetas: {
                items: [],
                opAt: "",
                organizationId: "",
            },
            CartonLabelAttachMetas: {
                items: [],
                opAt: "",
                organizationId: "",
            },
            PalletLabelAttachMetas: {
                items: [],
                opAt: "",
                organizationId: "",
            },
            itemlabelAttachMetas: {
                items: [],
                opAt: "",
                organizationId: "",
            },
            bolProps: {
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                data: {
                    srcLabel: this.sourceNo,
                    model: "deliverorder",
                    type: "bol",
                },
            },
            shiplabelProps: {
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                data: {
                    srcLabel: this.sourceNo,
                    model: "deliverorder",
                    type: "shiplabel",
                },
            },
            CartonLabelProps: {
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                data: {
                    srcLabel: this.sourceNo,
                    model: "deliverorder",
                    type: "cartonlabel",
                },
            },
            PalletLabelProps: {
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                data: {
                    srcLabel: this.sourceNo,
                    model: "deliverorder",
                    type: "palletlabel",
                },
            },
            itemlabelProps: {
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                data: {
                    srcLabel: this.sourceNo,
                    model: "deliverorder",
                    type: "itemlabel",
                },
            },
        };
    },
    created() {
        this.serviceCodeList = localStorage.getItem("@b2cServiceCodeList");

        // 筛选出label以FBA-开头的服务
        this.fbaServices = this.serviceCodeList.filter(
            (item) => item.label && item.label.startsWith("FBA-")
        );
    },
    watch: {},
    components: {
        compMutiUpload: () => import("@components/templates/mutiUpload"),
    },
    computed: {
        required() {
            return [
                {
                    required: true,
                    message: this.$t("global.common.required", {
                        defaultValue: "此项不能为空，请填写",
                    }),
                },
            ];
        },
    },
    methods: {
        changeShippingMethod(selectedValue) {
            // 通过选中的 value 找到对应的完整 item
            this.selectedItem = this.fbaServices.find(
                (item) => item.value === selectedValue
            );
            this.shiplabelAttachMetas.items = [];
            this.bolAttachMetas.items = [];
            this.CartonLabelAttachMetas.items = [];
            this.PalletLabelAttachMetas.items = [];
            this.itemlabelAttachMetas.items = [];
        },
        cancelUpload() {
            this.shiplabelOperate.show = false;
            this.bolOperate.show = false;
            this.CartonLabelOperate.show = false;
            this.PalletLabelOperate.show = false;
            this.itemlabelOperate.show = false;
        },
        //shiplabel
        shiplabelClearPropUpload(index) {
            this.shiplabelAttachMetas.items.splice(index, 1);
        },
        shiplabelPropFile() {
            if (this.formData.shippingMethodCode == null) {
                this.$Message.error("请先选择发货方式");
                return;
            }
            this.shiplabelOperate.show = true;
        },
        shiplabelSuccess(res) {
            window.console.log("resresresresres", res);
            if (res) {
                this.shiplabelAttachMetas.items.push(res.originData[0].entity);
                this.shiplabelAttachMetas.opAt = res.opAt;
                this.shiplabelAttachMetas.organizationId = res.organizationId;
            }
            this.cancelUpload();
        },
        //bol
        bolClearPropUpload(index) {
            this.bolAttachMetas.items.splice(index, 1);
        },
        bolPropFile() {
            if (this.formData.shippingMethodCode == null) {
                this.$Message.error("请先选择发货方式");
                return;
            }
            this.bolOperate.show = true;
        },
        bolSuccess(res) {
            if (res) {
                this.bolAttachMetas.items.push(res.originData[0].entity);
                this.bolAttachMetas.opAt = res.opAt;
                this.bolAttachMetas.organizationId = res.organizationId;
            }
            this.cancelUpload();
        },
        //CartonLabel
        CartonLabelClearPropUpload(index) {
            this.CartonLabelAttachMetas.items.splice(index, 1);
        },
        CartonLabelPropFile() {
            if (this.formData.shippingMethodCode == null) {
                this.$Message.error("请先选择发货方式");
                return;
            }
            this.CartonLabelOperate.show = true;
        },
        CartonLabelSuccess(res) {
            if (res) {
                this.CartonLabelAttachMetas.items.push(
                    res.originData[0].entity
                );
                this.CartonLabelAttachMetas.opAt = res.opAt;
                this.CartonLabelAttachMetas.organizationId = res.organizationId;
            }
            this.cancelUpload();
        },
        //PalletLabel
        PalletLabelClearPropUpload(index) {
            this.PalletLabelAttachMetas.items.splice(index, 1);
        },
        PalletLabelPropFile() {
            if (this.formData.shippingMethodCode == null) {
                this.$Message.error("请先选择发货方式");
                return;
            }
            this.PalletLabelOperate.show = true;
        },
        PalletLabelSuccess(res) {
            if (res) {
                this.PalletLabelAttachMetas.items.push(
                    res.originData[0].entity
                );
                this.PalletLabelAttachMetas.opAt = res.opAt;
                this.PalletLabelAttachMetas.organizationId = res.organizationId;
            }
            this.cancelUpload();
        },
        //itemlabel
        itemlabelClearPropUpload(index) {
            this.itemlabelAttachMetas.items.splice(index, 1);
        },
        itemlabelPropFile() {
            if (this.formData.shippingMethodCode == null) {
                this.$Message.error("请先选择发货方式");
                return;
            }
            this.itemlabelOperate.show = true;
        },
        itemlabelSuccess(res) {
            if (res) {
                this.itemlabelAttachMetas.items.push(res.originData[0].entity);
                this.itemlabelAttachMetas.opAt = res.opAt;
                this.itemlabelAttachMetas.organizationId = res.organizationId;
            }
            this.cancelUpload();
        },
        submit() {
            this.attachMetas = []; //防止再次提交，清空attachMetas

            if (this.formData.channelMethodCode == null) {
                this.$Message.error("请填写平台承运商");
                return;
            }
            const regex = /^[A-Z]{4}$/; // 匹配4个大写字母
            if (!regex.test(this.formData.channelMethodCode)) {
                this.$Message.error("平台承运商必须输入4个大写字母");
                return;
            }

            if (this.formData.shippingMethodCode == null) {
                this.$Message.error("请选择发货方式");
                return;
            }

            if (
                this.formData.shippingMethodCode == "FBA-LTL" &&
                this.bolAttachMetas.items.length === 0
            ) {
                this.$VMessage.error("BOL附件不能为空");
                return;
            }

            if (
                this.formData.shippingMethodCode != "FBA-LTL" &&
                this.shiplabelAttachMetas.items.length === 0
            ) {
                this.$VMessage.error("Shippinglabel附件不能为空");
                return;
            }

            if (this.CartonLabelAttachMetas.items.length === 0) {
                this.$VMessage.error("CartonLabel附件不能为空");
                return;
            } else {
                const map = {
                    type: "CartonLabel",
                    ucAttachItemEntity: this.CartonLabelAttachMetas.items[0],
                };
                this.attachMetas.push(map);
            }

            if (
                this.formData.shippingMethodCode == "FBA-LTL" &&
                this.bolAttachMetas.items.length != 0
            ) {
                const map = {
                    type: "BOL",
                    ucAttachItemEntity: this.bolAttachMetas.items[0],
                };
                this.attachMetas.push(map);
            }

            if (
                this.formData.shippingMethodCode != "FBA-LTL" &&
                this.shiplabelAttachMetas.items.length != 0
            ) {
                const map = {
                    type: "Shippinglabel",
                    ucAttachItemEntity: this.shiplabelAttachMetas.items[0],
                };
                this.attachMetas.push(map);
            }

            if (
                this.formData.shippingMethodCode == "FBA-LTL" &&
                this.PalletLabelAttachMetas.items.length != 0
            ) {
                const map = {
                    type: "PalletLabel",
                    ucAttachItemEntity: this.PalletLabelAttachMetas.items[0],
                };
                this.attachMetas.push(map);
            }

            if (this.itemlabelAttachMetas.items.length != 0) {
                const map = {
                    type: "itemlabel",
                    ucAttachItemEntity: this.itemlabelAttachMetas.items[0],
                };
                this.attachMetas.push(map);
            }
            if (this.selectedItem.attach.carrierCode == null) {
                this.selectedItem.attach.carrierCode =
                    this.selectedItem.attach.carrierServiceCode.substring(4);
            }
            this.loading = true;
            HttpPoUploadAttach({
                id: this.id,
                attachMetas: this.attachMetas,
                carrierCode: this.selectedItem.attach.carrierCode,
                customerCarrierServiceCode:
                    this.selectedItem.attach.carrierServiceCode,
                channelMethodCode: this.formData.channelMethodCode,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.loading = false;
                    this.$emit("on-close");
                    this.$emit("on-update");
                    this.$emit("refreshPage");
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
    },
};
</script>

<style lang="scss">
.reimbursementUpload {
    .upload {
        display: inline-block;
        min-width: 440px;
        padding-left: 10px;
        .upload-item {
            display: flex;
            color: #3399ff;
            .filename {
                width: 40%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .close {
                margin-left: 5px;
                &:hover {
                    color: red;
                    cursor: pointer;
                }
            }
        }
    }
}
.but {
    width: 100px;
}
</style>
